
const state = () => ({
  images: [],
  slides: [],
  index: null
})

const mutations = {
  setImages (state, images) {
    state.images = images
  },
  setIndex (state, index) {
    state.index = index
  },
  setSlides (state, slides) {
    state.slides = slides
  }
}

const actions = {
  openGallery ({ commit }, { slides, index, gtag }) {
    const slide = slides[index]
    gtag.event(
      'zoom_view',
      {
        event_category: 'engagement',
        event_label: slide.title
      }
    )
    commit('setImages', slides.map(s => ({ url: s.image, title: s.title })))
    commit('setIndex', index)
    commit('setSlides', slides)
  },
  closeGallery ({ commit }, { gtag }) {
    gtag.event(
      'zoom_view_close',
      {
        event_category: 'engagement'
      }
    )
    commit('setIndex', null)
  },
  trackNextSlide ({ commit, state }, { gtag, index }) {
    const slide = state.slides[index]
    commit('setIndex', index)
    gtag.event(
      'zoom_view_scroll',
      {
        event_category: 'engagement',
        event_label: slide.title
      }
    )
  }
}
export default { namespaced: true, state, actions, mutations }
